import { TABLE } from 'reporting-data/constants/chartTypes';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { SelectedReports } from 'reporting-action-components/reportingActions/exportReport/ExportReportButton';
import { SRVDatasetTableActionsBar } from '../../../common/dataset-tables/SRVDatasetTableActionsBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const JourneyReportSRVTable = props => {
  const {
    previewReport,
    suppressActionsBar = false
  } = props;
  const reportForTable = previewReport.set('chartType', TABLE).setIn(['journeyQuery', 'includeDropoffs'], false).remove('id');
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "full-page-srv-journey-table",
    children: [!suppressActionsBar && /*#__PURE__*/_jsx(SRVDatasetTableActionsBar, {
      report: reportForTable,
      selectedReport: SelectedReports.summarizedTable
    }), /*#__PURE__*/_jsx(PlatformReportResolver, {
      report: reportForTable,
      enableReportResolveUsageTracking: false
    })]
  });
};
export default JourneyReportSRVTable;